// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#content-header-divider[data-v-1764c9d6]{margin-top:0;margin-bottom:0}", ""]);
// Exports
module.exports = exports;
